<template>
  <div class="w3-left-align">
    <i class="fa fa-arrows-alt flow-main-color w3-xlarge w3-margin-right"></i>
    <content-header v-bind:title="$t('addNewInstruction')"></content-header>
    <div class="w3-margin-top w3-margin-bottom w3-left-align">
      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <p class="flow-padding-bottom zero-top w-70pc">
          <label class="w3-left flow-main-color flow-padding-bottom">{{
            $t("walking-ins-domain")
          }}</label>
          <flow-select
            class="w3-border w3-round-medium"
            type="text"
            :items="domains"
            :valueKey="'name'"
            :valueKeyIndex="'id'"
            :callback="setSelectedDomain"
          >
          </flow-select>
        </p>
      </div>

      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <p class="flow-padding-bottom zero-top w-70pc">
          <label class="w3-left flow-main-color flow-padding-bottom">{{
            $t("regime")
          }}</label>
          <flow-select
            class="w3-border w3-round-medium"
            type="text"
            :items="regimes"
            :valueKey="'name'"
            :valueKeyIndex="'id'"
            :callback="setSelectedRegime"
          >
          </flow-select>
        </p>
      </div>

      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <span
          v-if="showKioskError"
          class="w3-text-red qpp-field-error-message qpp-field-error-message-domain"
          >{{ $t("kiosk-is-mandatory") }}</span
        >
        <p class="flow-padding-bottom zero-top w-70pc">
          <label class="w3-left flow-main-color flow-padding-bottom">{{
            $t("kiosk")
          }}</label>
          <flow-select
            class="w3-border w3-round-medium"
            type="text"
            :items="kiosks"
            :valueKey="'username'"
            :valueKeyIndex="'id'"
            :callback="setSelectedKiosk"
          >
          </flow-select>
        </p>
      </div>

      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <p class="flow-padding-bottom zero-top w-70pc">
          <label class="w3-left flow-main-color flow-padding-bottom">{{
            $t("destination")
          }}</label>
          <flow-select
            class="w3-border w3-round-medium"
            type="text"
            :items="waitingRooms"
            :valueKey="'name'"
            :valueKeyIndex="'id'"
            :callback="setSelectedRoom"
          >
          </flow-select>
        </p>
      </div>

      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <p class="zero-top w-70pc">
          <label class="flow-main-color">{{
            $t("register-appointment")
          }}</label>
          <br />
          <input
            type="checkbox"
            id="appointment-signin"
            name=""
            class="w3-check"
            v-model="newInstruction.registerAppointment"
          />
        </p>
      </div>

      <div
        class="w3-container w3-block flow-form-inline-input flow-margin-bottom"
        style="padding-bottom: 10px"
      >
        <div class=" zero-top w-38pc" style="display: inline-block">
          <label class="w3-left flow-main-color ">{{ $t("validFrom") }}</label>
          <input
            type="date"
            id="valid-from"
            name=""
            class="w-80pc"
            v-model="newInstruction.validFrom"
            style=""
          />
        </div>
        <div class=" zero-top w-38pc" style="display: inline-block">
          <label class="w3-left flow-main-color ">{{ $t("validUntil") }}</label>
          <input
            type="date"
            id="valid-until"
            name=""
            class="w-80pc"
            v-model="newInstruction.validUntil"
            style=""
          />
        </div>
      </div>

      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <p class="flow-padding-bottom zero-top w-70pc">
          <label class="w3-left flow-main-color flow-padding-bottom">{{
            $t("standard-text")
          }}</label>
          <flow-select
            class="w3-border w3-round-medium"
            type="text"
            :items="standardTexts"
            :valueKey="'value'"
            :valueKeyIndex="'key'"
            :callback="setSelectedStandardText"
          >
          </flow-select>
        </p>
      </div>

      <div class="w3-container zero-bottom w3-block flow-form-inline-input">
        <input
          type="radio"
          id="arrow"
          name="visual_instruction"
          v-model="computedInstruction.enableImage"
          :value="false"
        />
        <label class="enableImage" for="arrow">{{ $t("arrow") }}</label>
        <input
          type="radio"
          id="image"
          name="visual_instruction"
          v-model="computedInstruction.enableImage"
          :value="true"
        />
        <label class="enableImage" for="image">{{ $t("image") }}</label
        ><br />
        <div v-if="!computedInstruction.enableImage">
          <button
            v-if="!computedInstruction.enableImage"
            class="qpp-walkIns-direction"
            @click="updateAngle"
          >
            <img
              v-if="angles[currentAngleIndex] != null"
              :src="require('@/assets/images/arrow.png')"
              :style="{
                transform: 'rotate(' + angles[currentAngleIndex] + 'deg)',
              }"
            />
          </button>
        </div>
        <div class="img-box" v-else>
          <div class="q-btn">
            <QButton
              :callback="openImageWindowEvent"
              :text="'chooseImage'"
              :icon="'far fa-images'"
            />
          </div>
          <img v-if="onSelectedImage" :src="onSelectedImage.url" />
        </div>
      </div>

      <div class="zero-bottom zero-top">
        <button
          class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top w3-margin-right"
          @click.prevent="addNewInstruction"
        >
          <i class="fa fa-save flow-green-active-color">
            <span
              ><b class="flow-margin-left">{{ $t("save") }}</b></span
            >
          </i>
        </button>

        <button
          class="flow-btn w3-btn w3-round w3-border w3-ripple w3-round-medium w3-margin-top"
          @click.prevent="onClose"
        >
          <i class="fa fa-arrow-left w3-text-red">
            <span
              ><b class="flow-margin-left">{{ $t("back") }}</b></span
            >
          </i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ContentHeader from "../../common/ContentHeader";
import FlowSelect from "@/components/common/FlowSelect";
import { mapGetters, mapActions } from "vuex";
import QButton from "../../common/buttons/QButton.vue";

export default {
  name: "NewWalkingInstruction",
  components: { ContentHeader, FlowSelect, QButton },
  emits: ["newInstructionAdded"],
  props: [
    "onClose",
    "domains",
    "waitingRooms",
    "kiosks",
    "regimes",
    "standardTexts",
    "defaultImage",
  ],
  data() {
    return {
      newInstruction: {
        validUntil: "2050-12-31",
        validFrom: "2000-01-01",
      },
      npNameError: undefined,
      directions: [
        { name: "top" },
        { name: "top right" },
        { name: "right" },
        { name: "bottom right" },
        { name: "bottom" },
        { name: "bottom left" },
        { name: "left" },
        { name: "top left" },
      ],
      angles: [0, 45, 90, 135, 180, -135, -90, -45, null],
      currentAngleIndex: 0,
      showKioskError: false,
    };
  },
  computed: {
    ...mapGetters({
      onSelectedImage: "instructionImages/onSelectedImage",
    }),
    computedInstruction: {
      get() {
        const instruction = this.newInstruction;
        const selectedImage = this.onSelectedImage;
        if (selectedImage !== null) {
          instruction.imageUrlId = selectedImage.id;
          instruction.imageUrl = selectedImage.url;
        }

        return instruction;
      },
    },
  },
  methods: {
    ...mapActions({
      openImageWindowEvent: "instructionImages/openWindowEvent",
      selectedImageEvent: "instructionImages/selectedImageEvent",
    }),
    addNewInstruction() {
      const app = this;
      app.showKioskError = false;
      this.newInstruction.arrowAngle = this.angles[this.currentAngleIndex];
      if (!app.newInstruction.kiosk || !app.newInstruction.kiosk.id) {
        app.showKioskError = true;
        return;
      }
      app.$restClient.walkingInstructions
        .add(this.computedInstruction)
        .then((response) => {
          // eslint-disable-next-line no-unused-vars
          let data = response.data;
          app.$notify.notifySuccess({
            title: this.$t("success"),
            message: this.$t("added-success"),
          });

          app.$emit("newInstructionAdded", data);
          app.onClose();
        })
        .catch((err) => {
          if (err && err.response.status === 400)
            app.$notify.notifyError({
              title: this.$t("failed"),
              message: this.$t("instruction-match-unique"),
            });
          else if (err && err.response.status === 427)
            app.$notify.notifyError({
              title: this.$t("failed"),
              message: this.$t("validity-interval-taken"),
            });
          else if (err && err.response.status === 428)
            app.$notify.notifyError({
              title: this.$t("failed"),
              message: this.$t("missing-kiosk-id"),
            });
          else if (err && err.response.status === 429)
            app.$notify.notifyError({
              title: this.$t("failed"),
              message: this.$t("missing-walking-instruction-fields"),
            });
          else if (err && err.response.status === 430)
            app.$notify.notifyError({
              title: this.$t("failed"),
              message: this.$t("missing-domain-or-regime"),
            });
          else app.$notify.notifyError({ title: this.$t("failed") });
        });
    },
    setSelectedDomain(domain) {
      this.newInstruction.domain = domain;
    },

    setSelectedRegime(regime) {
      this.newInstruction.regime = regime;
    },

    setSelectedKiosk(kiosk) {
      const app = this;
      app.showKioskError = false;
      this.newInstruction.kiosk = kiosk;
    },

    setSelectedRoom(room) {
      this.newInstruction.waitingRoom = room;
    },

    setSelectedImage(image) {
      this.newInstruction.arrowAngle = image.name;
    },

    setSelectedStandardText(text) {
      this.newInstruction.standardText = text;
    },

    updateAngle() {
      this.currentAngleIndex++;
      if (this.currentAngleIndex === 9) this.currentAngleIndex = 0;
    },
  },
  created() {
    this.selectedImageEvent(this.defaultImage);
    this.newInstruction.enableImage = false;
  },
  mounted() {
    let date = new Date();
    let dateString =
      date.getFullYear() +
      "-" +
      ("0" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + date.getDate()).slice(-2);
    this.newInstruction.validFrom = dateString;
    this.newInstruction.registerAppointment = true;
  },
};
</script>

<style scoped>
.enableImage {
  padding-left: 8px;
  padding-right: 8px;
}

.img-box img {
  width: 40%;
  height: 40%;
  object-fit: contain;
}

.q-btn {
  min-width: 10%;
}

.img-box {
  height: 8vw;
  width: auto;
  display: flex;
  align-items: center;
}
</style>
